import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import ClaytonLogo from './ClaytonLogo';

import { ccpaScriptSource } from "../../services/settingService";
import { HeaderStyles } from './Header.styled';
import { saveUTMSessionParams } from "pubweb-smokey/dist/utils/utils";

if (typeof (window) !== "undefined" && typeof (document) !== "undefined" && !document.getElementById("ccpa_script")) {
    let source = ccpaScriptSource;
    let script = document.createElement('script');
    script.src = source;
    script.defer = true;
    script.id = "ccpa_script";
    script.setAttribute("data-id", "ccpa-banner");
    script.setAttribute("data-first-link-text", "Privacy Policy");
    script.setAttribute("data-first-link-href", "https://www.claytonhomes.com/privacy/");
    document.getElementsByTagName("head")[0].appendChild(script);
}

const Header = () => {

    // save any utm params to local session cache
    const pageRouterLocation = useLocation().search;
    useEffect(() => {
        saveUTMSessionParams(pageRouterLocation);
    }, []);
    
    return (
        <HeaderStyles>
            <header>
            <ClaytonLogo className="clayton-logo" alt="Clayton Logo"/>
            <p>Call Us <a href="tel:+1-866-305-4179"><span className="phone">866-305-4179</span></a></p>
            </header>
        </HeaderStyles>
    )
}

export default Header;
